export const navigationSections = [
  {
    heading: "Workspace",

    items: [
      {
        label: "Dashboard",
        to: "/",
        activePrefix: "/",
        exact: true,
        permission:
          "view_dashboard",
      },
    ],
  },

  {
    heading: "Operations",

    items: [
      {
        label: "Activity",
        to: "/activity",
        activePrefix:
          "/activity",
        permission:
          "view_activity",
      },

      {
        label:
          "Wi-Fi analytics",
        to:
          "/traffic-analytics",
        activePrefix:
          "/traffic-analytics",
        permission:
          "view_traffic_analytics",
      },

      {
        label: "Vouchers",
        to: "/vouchers",
        activePrefix:
          "/vouchers",
        permission:
          "view_vouchers",
      },

      {
        label: "Shops",
        to: "/shops",
        activePrefix:
          "/shops",
        permission:
          "view_shops",
      },

      {
        label:
          "Wi-Fi packages",
        to:
          "/wifi-packages",
        activePrefix:
          "/wifi-packages",
        permission:
          "view_wifi_packages",
      },
    ],
  },

  {
    heading:
      "Administration",

    items: [
      {
        label: "Users",
        to:
          "/access/users",
        activePrefix:
          "/access/users",
        permission:
          "manage_users",
      },

      {
        label: "Roles",
        to:
          "/access/roles",
        activePrefix:
          "/access/roles",
        permission:
          "manage_roles",
      },

      {
        label:
          "Permissions",
        to:
          "/access/permissions",
        activePrefix:
          "/access/permissions",
        permission:
          "manage_permissions",
      },

      {
        label: "Brands",
        to: "/brands",
        activePrefix:
          "/brands",
        permission:
          "view_brands",
      },

      {
        label:
          "Currencies",
        to:
          "/currencies",
        activePrefix:
          "/currencies",
        permission:
          "view_currencies",
      },
    ],
  },

  {
    heading: "System",

    items: [
      {
        label:
          "Firewall configuration",
        to:
          "/system/firewall-configuration",
        activePrefix:
          "/system/firewall-configuration",
        permission:
          "view_sophos_firewalls",
      },

      {
        label:
          "Settings",
        to: "/settings",
        activePrefix:
          "/settings",
      },
    ],
  },
];

const routeMeta = [
  [
    "/",
    "Dashboard",
    ["Dashboard"],
  ],

  [
    "/activity",
    "Activity",
    [
      "Operations",
      "Activity",
    ],
  ],

  [
    "/traffic-analytics",
    "Wi-Fi analytics",
    [
      "Operations",
      "Wi-Fi analytics",
    ],
  ],

  [
    "/vouchers",
    "Vouchers",
    [
      "Operations",
      "Vouchers",
    ],
  ],

  [
    "/shops",
    "Shops",
    [
      "Operations",
      "Shops",
    ],
  ],

  [
    "/wifi-packages",
    "Wi-Fi packages",
    [
      "Operations",
      "Wi-Fi packages",
    ],
  ],

  [
    "/shop-wifi-package-rules",
    "Shop Wi-Fi rules",
    [
      "Operations",
      "Shop Wi-Fi rules",
    ],
  ],

  [
    "/rules",
    "Rules",
    [
      "Operations",
      "Rules",
    ],
  ],

  [
    "/pos-clients",
    "POS clients",
    [
      "Operations",
      "POS clients",
    ],
  ],

  [
    "/access/users",
    "Users",
    [
      "Administration",
      "Users",
    ],
  ],

  [
    "/access/roles",
    "Roles",
    [
      "Administration",
      "Roles",
    ],
  ],

  [
    "/access/permissions",
    "Permissions",
    [
      "Administration",
      "Permissions",
    ],
  ],

  [
    "/brands",
    "Brands",
    [
      "Administration",
      "Brands",
    ],
  ],

  [
    "/currencies",
    "Currencies",
    [
      "Administration",
      "Currencies",
    ],
  ],

  [
    "/system/firewall-configuration",
    "Firewall configuration",
    [
      "System",
      "Firewall configuration",
    ],
  ],

  [
    "/settings",
    "Settings",
    [
      "System",
      "Settings",
    ],
  ],
];

export function getRouteMeta(
  pathname,
) {
  const match =
    routeMeta.find(
      ([prefix]) => {
        if (
          prefix === "/"
        ) {
          return (
            pathname === "/"
          );
        }

        return pathname.startsWith(
          prefix,
        );
      },
    );

  if (!match) {
    return {
      title:
        "Management",

      breadcrumbs: [
        "Management",
      ],
    };
  }

  return {
    title: match[1],

    breadcrumbs:
      match[2],
  };
}